import { render, staticRenderFns } from "./SettingsSecurity.vue?vue&type=template&id=44aa161c&"
import script from "./SettingsSecurity.vue?vue&type=script&lang=js&"
export * from "./SettingsSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports